import { useEffect, useState } from 'react';
import { useDisplayZone } from '../../lib/useDisplayZone';
import { formatZoneTime } from '../../lib/zoneTime';

/** Header time in the tenant's zone, ticking every 30s: `18:19 Nairobi`. */
export function ZoneClock() {
  const zone = useDisplayZone();
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 30_000);
    return () => clearInterval(t);
  }, []);
  return (
    <span className="hidden text-sm text-ink-muted sm:inline" title={`Time in ${zone}`}>
      <span className="tabular-nums">{formatZoneTime(now, zone)}</span> {zone.split('/').pop()?.replace(/_/g, ' ')}
    </span>
  );
}
